export const MENU_ITEM_CLASS =
  "flex h-9 w-full items-center gap-2 neeto-ui-rounded-md px-2.5 text-sm font-medium hover:bg-accent";
